//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class BackendApiV1 {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    /**
     * Executes the authentication of the specified user
     * @return JWT Token incl. authentication details of the logged in user
     */
    postAuthenticate(body: LoginRequestDto, cancelToken?: CancelToken): Promise<AuthResponseDto> {
        let url_ = this.baseUrl + "/api/v1/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostAuthenticate(_response);
        });
    }

    protected processPostAuthenticate(response: AxiosResponse): Promise<AuthResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthResponseDto.fromJS(resultData200);
            return Promise.resolve<AuthResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case of invalid parameters", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthResponseDto>(null as any);
    }

    /**
     * Log outs the user and invalidates the token
     * @return In case logout was successfully processed
     */
    postLogout( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostLogout(_response);
        });
    }

    protected processPostLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Validates if the password is correct
     * @return In case when the specified password is valid
     */
    postValidatePassword(body: ValidatePasswordRequestDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/password/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostValidatePassword(_response);
        });
    }

    protected processPostValidatePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case no or incorrect parameters were transmitted", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns all available Betrieb objects
     * @return Array containing Betrieb objects
     */
    getAllBetriebe( cancelToken?: CancelToken): Promise<BetriebeWithChecklistenEingabenResponseDto> {
        let url_ = this.baseUrl + "/api/v1/betrieb/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllBetriebe(_response);
        });
    }

    protected processGetAllBetriebe(response: AxiosResponse): Promise<BetriebeWithChecklistenEingabenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BetriebeWithChecklistenEingabenResponseDto.fromJS(resultData200);
            return Promise.resolve<BetriebeWithChecklistenEingabenResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("In case no Betrieb found for the specified id", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BetriebeWithChecklistenEingabenResponseDto>(null as any);
    }

    /**
     * Retrieves the Betrieb by filtering on the specified Id
     * @return Returns Betrieb if found
     */
    getBetriebById(id: number, cancelToken?: CancelToken): Promise<BetriebWithChecklistenEingabenResponseDto> {
        let url_ = this.baseUrl + "/api/v1/betrieb/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBetriebById(_response);
        });
    }

    protected processGetBetriebById(response: AxiosResponse): Promise<BetriebWithChecklistenEingabenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BetriebWithChecklistenEingabenResponseDto.fromJS(resultData200);
            return Promise.resolve<BetriebWithChecklistenEingabenResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("In case no Betrieb found for the specified id", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BetriebWithChecklistenEingabenResponseDto>(null as any);
    }

    /**
     * Creates new Betrieb
     * @return In case the Betrieb has been successfully created
     */
    postBetrieb(body: BetriebRequestDto, cancelToken?: CancelToken): Promise<BetriebResponseDto> {
        let url_ = this.baseUrl + "/api/v1/betrieb";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostBetrieb(_response);
        });
    }

    protected processPostBetrieb(response: AxiosResponse): Promise<BetriebResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = BetriebResponseDto.fromJS(resultData201);
            return Promise.resolve<BetriebResponseDto>(result201);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authorized", status, _responseText, _headers, result401);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("In case the Betrieb does already exists", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BetriebResponseDto>(null as any);
    }

    /**
     * Checks if the specified VVVO is already known in the system
     * @return In case the existence of the specified VVVO has been checked successfully
     */
    postCheckVvvo(body: CheckVvvoRequestDto, cancelToken?: CancelToken): Promise<CheckVvvoResponseDto> {
        let url_ = this.baseUrl + "/api/v1/betrieb/vvvo/check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostCheckVvvo(_response);
        });
    }

    protected processPostCheckVvvo(response: AxiosResponse): Promise<CheckVvvoResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CheckVvvoResponseDto.fromJS(resultData200);
            return Promise.resolve<CheckVvvoResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case the specified VVVO isn\'t valid", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CheckVvvoResponseDto>(null as any);
    }

    /**
     * Create authorization request for the specified unknown VVVO
     * @return In case new Betrieb has been created and the authorization request has been successfully proceed
     */
    postRequestAuthorizationForNewVvvo(body: RequestNewUserVvvoAuthorizationRequestDto, cancelToken?: CancelToken): Promise<RequestNewUserVvvoAuthorizationResponseDto> {
        let url_ = this.baseUrl + "/api/v1/betrieb/vvvo/authorization/request/new";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostRequestAuthorizationForNewVvvo(_response);
        });
    }

    protected processPostRequestAuthorizationForNewVvvo(response: AxiosResponse): Promise<RequestNewUserVvvoAuthorizationResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = RequestNewUserVvvoAuthorizationResponseDto.fromJS(resultData201);
            return Promise.resolve<RequestNewUserVvvoAuthorizationResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case the specified data isn\'t valid", status, _responseText, _headers, result400);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("In case Betrieb already exists", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RequestNewUserVvvoAuthorizationResponseDto>(null as any);
    }

    /**
     * Create authorization request for the specified existing and known VVVO
     * @return In case the authorization request has been successfully proceed
     */
    postRequestAuthorizationForExistingVvvo(body: RequestExistingUserVvvoAuthorizationRequestDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/betrieb/vvvo/authorization/request/existing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostRequestAuthorizationForExistingVvvo(_response);
        });
    }

    protected processPostRequestAuthorizationForExistingVvvo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("In case the existing Betrieb has not been found", status, _responseText, _headers, result404);

        } else if (status === 409) {
            const _responseText = response.data;
            let result409: any = null;
            let resultData409  = _responseText;
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("In case VVVO-Authorization already exists", status, _responseText, _headers, result409);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Resend an authorization request email
     * @return In case the authorization request email has been successfully sent
     */
    resendAuthorizationEmail(betriebId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/betrieb/vvvo/authorization/request/retry/{betriebId}";
        if (betriebId === undefined || betriebId === null)
            throw new Error("The parameter 'betriebId' must be defined.");
        url_ = url_.replace("{betriebId}", encodeURIComponent("" + betriebId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendAuthorizationEmail(_response);
        });
    }

    protected processResendAuthorizationEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("In case when the Betrieb or Authorization request weren\'t found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Confirm VVVO authorization
     * @return In case the authorization confirmation request has been successfully proceed
     */
    postConfirmUserVvvoAuthorization(body: ConfirmUserVvvoAuthorizationRequestDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/betrieb/vvvo/authorization/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostConfirmUserVvvoAuthorization(_response);
        });
    }

    protected processPostConfirmUserVvvoAuthorization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case the specified data isn\'t valid", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("In case the authorization request has not been found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Reject VVVO authorization
     * @return In case the authorization rejection request has been successfully proceed
     */
    postRejectUserVvvoAuthorization(body: RejectUserVvvoAuthorizationRequestDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/betrieb/vvvo/authorization/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostRejectUserVvvoAuthorization(_response);
        });
    }

    protected processPostRejectUserVvvoAuthorization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case the specified data isn\'t valid", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("In case the authorization request has not been found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes an authorization
     * @return In case the authorization was successfully deleted
     */
    deleteAuthorization(betriebId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/betrieb/vvvo/authorization/delete/{betriebId}";
        if (betriebId === undefined || betriebId === null)
            throw new Error("The parameter 'betriebId' must be defined.");
        url_ = url_.replace("{betriebId}", encodeURIComponent("" + betriebId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAuthorization(_response);
        });
    }

    protected processDeleteAuthorization(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("In case when the Betrieb wasn\'t found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Return all latest valid Checklisten
     * @return List of the currently available Checklisten.
     */
    getLatestValidChecklisten( cancelToken?: CancelToken): Promise<ChecklistenResponseDto> {
        let url_ = this.baseUrl + "/api/v1/checklisten";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLatestValidChecklisten(_response);
        });
    }

    protected processGetLatestValidChecklisten(response: AxiosResponse): Promise<ChecklistenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case of invalid parameters", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChecklistenResponseDto.fromJS(resultData200);
            return Promise.resolve<ChecklistenResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChecklistenResponseDto>(null as any);
    }

    /**
     * Retrieves existing ChecklistenEingaben for the specified Betrieb
     * @return List of existing ChecklistenEingaben filtered by specified Betrieb
     */
    getChecklistenEingaben(betriebId: number, cancelToken?: CancelToken): Promise<ChecklistenOverviewResponseDto> {
        let url_ = this.baseUrl + "/api/v1/checklistenEingaben/{betriebId}";
        if (betriebId === undefined || betriebId === null)
            throw new Error("The parameter 'betriebId' must be defined.");
        url_ = url_.replace("{betriebId}", encodeURIComponent("" + betriebId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChecklistenEingaben(_response);
        });
    }

    protected processGetChecklistenEingaben(response: AxiosResponse): Promise<ChecklistenOverviewResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case of invalid parameters", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChecklistenOverviewResponseDto.fromJS(resultData200);
            return Promise.resolve<ChecklistenOverviewResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChecklistenOverviewResponseDto>(null as any);
    }

    /**
     * Saves specified ChecklistenEingaben
     * @return In case the ChecklistenEingaben have been saved successfully
     * @deprecated
     */
    postChecklistenEingaben(body: AddChecklistenEingabenRequestDto, cancelToken?: CancelToken): Promise<AddChecklistenEingabenResponseDto> {
        let url_ = this.baseUrl + "/api/v1/checklistenEingaben";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostChecklistenEingaben(_response);
        });
    }

    protected processPostChecklistenEingaben(response: AxiosResponse): Promise<AddChecklistenEingabenResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case of invalid parameters", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = AddChecklistenEingabenResponseDto.fromJS(resultData201);
            return Promise.resolve<AddChecklistenEingabenResponseDto>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddChecklistenEingabenResponseDto>(null as any);
    }

    /**
     * Saves specified ChecklistenEingabe
     * @return In case the ChecklistenEingabe have been saved successfully
     * @deprecated
     */
    postChecklistenEingabe(body: AddChecklistenEingabeRequestDto, cancelToken?: CancelToken): Promise<AddChecklistenEingabeResponseDto> {
        let url_ = this.baseUrl + "/api/v1/checklistenEingabe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostChecklistenEingabe(_response);
        });
    }

    protected processPostChecklistenEingabe(response: AxiosResponse): Promise<AddChecklistenEingabeResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case of invalid parameters", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = AddChecklistenEingabeResponseDto.fromJS(resultData201);
            return Promise.resolve<AddChecklistenEingabeResponseDto>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddChecklistenEingabeResponseDto>(null as any);
    }

    /**
     * Retrieves the Checklisten Eingabe record matching the specified id.
     * @return Response containing Checklisten Eingabe record
     * @deprecated
     */
    getChecklistenEingabe(id: number, cancelToken?: CancelToken): Promise<GetChecklistenEingabeResponseDto> {
        let url_ = this.baseUrl + "/api/v1/checklistenEingabe/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetChecklistenEingabe(_response);
        });
    }

    protected processGetChecklistenEingabe(response: AxiosResponse): Promise<GetChecklistenEingabeResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case of invalid parameters", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetChecklistenEingabeResponseDto.fromJS(resultData200);
            return Promise.resolve<GetChecklistenEingabeResponseDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetChecklistenEingabeResponseDto>(null as any);
    }

    /**
     * Deletes a ChecklistenEingabe
     * @return In case the ChecklistenEingabe was successfully deleted
     * @deprecated
     */
    deleteChecklistenEingabe(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/checklistenEingabe/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteChecklistenEingabe(_response);
        });
    }

    protected processDeleteChecklistenEingabe(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case of invalid parameters", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Serves ChecklistenEingabe as PDF
     * @return Response containing Checklisten Eingabe record as pdf
     * @deprecated
     */
    getPdfChecklistenEingabe(id: number, cancelToken?: CancelToken): Promise<PdfResponseDto> {
        let url_ = this.baseUrl + "/api/v1/checklistenEingabe/{id}/pdf";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPdfChecklistenEingabe(_response);
        });
    }

    protected processGetPdfChecklistenEingabe(response: AxiosResponse): Promise<PdfResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case of invalid parameters", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PdfResponseDto.fromJS(resultData200);
            return Promise.resolve<PdfResponseDto>(result200);

        } else if (status === 422) {
            const _responseText = response.data;
            let result422: any = null;
            let resultData422  = _responseText;
            result422 = PdfTemplateValidationResultDto.fromJS(resultData422);
            return throwException("In case the PdfTemplate or ChecklistenEingabe is mismatch to the correspond Checkliste by fields", status, _responseText, _headers, result422);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PdfResponseDto>(null as any);
    }

    /**
     * Gibt Übersetzungen für eine bestimmte Sprache zurück
     * @return Übersetzungen
     */
    getTranslations( cancelToken?: CancelToken): Promise<TranslationsResponseDto> {
        let url_ = this.baseUrl + "/api/v1/translations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTranslations(_response);
        });
    }

    protected processGetTranslations(response: AxiosResponse): Promise<TranslationsResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TranslationsResponseDto.fromJS(resultData200);
            return Promise.resolve<TranslationsResponseDto>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("Internal server error.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TranslationsResponseDto>(null as any);
    }

    /**
     * Creates a new user
     * @return The location containing created user details
     */
    postCreateUser(body: CreateUserRequestDto, cancelToken?: CancelToken): Promise<UserResponseDto> {
        let url_ = this.baseUrl + "/api/v1/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostCreateUser(_response);
        });
    }

    protected processPostCreateUser(response: AxiosResponse): Promise<UserResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = UserResponseDto.fromJS(resultData201);
            return Promise.resolve<UserResponseDto>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case no or incorrect parameters were transmitted", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserResponseDto>(null as any);
    }

    /**
     * Validates the email
     * @return In case when the specified email is valid
     */
    postValidateEmail(body: ValidateEmailRequestDto, cancelToken?: CancelToken): Promise<ValidateEmailResponseDto> {
        let url_ = this.baseUrl + "/api/v1/user/email/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostValidateEmail(_response);
        });
    }

    protected processPostValidateEmail(response: AxiosResponse): Promise<ValidateEmailResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ValidateEmailResponseDto.fromJS(resultData200);
            return Promise.resolve<ValidateEmailResponseDto>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case no or incorrect parameters were transmitted", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authenticated", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateEmailResponseDto>(null as any);
    }

    /**
     * Sends user creation email
     * @return Success
     */
    postSendUserCreationEmail(body: SendUserCreationEmailRequestDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/send-email/user-creation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostSendUserCreationEmail(_response);
        });
    }

    protected processPostSendUserCreationEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case invalid parameters specified", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Confirms email address of an user
     * @return In case the email address has been successfully confirmed
     */
    postConfirmEmail(body: ConfirmEmailRequestDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/email/confirm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostConfirmEmail(_response);
        });
    }

    protected processPostConfirmEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case invalid parameters specified", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of any internal server error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Sends email "Change email address request" containing confirmation link for email address change to the specified email address
     * @return In case the email has been successfully sent
     */
    postRequestChangeEmail(body: RequestChangeEmailRequestDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/email/request/change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostRequestChangeEmail(_response);
        });
    }

    protected processPostRequestChangeEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case no or incorrect parameters were transmitted", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Changes the email address of the specified user
     * @return In case the email address has been successfully changed
     */
    postConfirmEmailChange(body: ChangeEmailRequestDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/email/confirm/change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostConfirmEmailChange(_response);
        });
    }

    protected processPostConfirmEmailChange(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case no or incorrect parameters were transmitted", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Sends password forgotten email to the specified email address
     * @return In case the password reset email have been successfully sent
     */
    postRequestPasswordReset(body: RequestPasswordResetRequestDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/password/request/reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostRequestPasswordReset(_response);
        });
    }

    protected processPostRequestPasswordReset(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("In case no or incorrect parameters were transmitted", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Resets the password of the specified user
     * @return In case the password have been successfully reset
     */
    postConfirmPasswordReset(body: ResetPasswordRequestDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/password/confirm/reset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostConfirmPasswordReset(_response);
        });
    }

    protected processPostConfirmPasswordReset(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case no or incorrect parameters were transmitted", status, _responseText, _headers, result400);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Changes the password of the current user
     * @return In case the password have been successfully changed
     */
    postChangePassword(body: ChangePasswordRequestDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/password/change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostChangePassword(_response);
        });
    }

    protected processPostChangePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case no or incorrect parameters were transmitted", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server errors", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Change the language of current user
     * @return In case the language has been successfully updated
     */
    putUpdateLanguage(language: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/user/language/change/{language}";
        if (language === undefined || language === null)
            throw new Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutUpdateLanguage(_response);
        });
    }

    protected processPutUpdateLanguage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case of invalid parameters", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authorized", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieves the userprofile for logged in user
     * @return Returns userprofile if found
     */
    getUserProfile( cancelToken?: CancelToken): Promise<UserProfileResponseDto> {
        let url_ = this.baseUrl + "/api/v1/userprofile";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserProfile(_response);
        });
    }

    protected processGetUserProfile(response: AxiosResponse): Promise<UserProfileResponseDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserProfileResponseDto.fromJS(resultData200);
            return Promise.resolve<UserProfileResponseDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("In case the user isn\'t authorized", status, _responseText, _headers, result401);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("In case the user don\'t have a profile yet", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserProfileResponseDto>(null as any);
    }

    /**
     * Updates user profile
     * @return In case when the user profile was successfully updated
     */
    putUserProfile(body: UserProfileRequestDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/userprofile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPutUserProfile(_response);
        });
    }

    protected processPutUserProfile(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            if (resultData400) {
                result400 = {} as any;
                for (let key in resultData400) {
                    if (resultData400.hasOwnProperty(key))
                        (<any>result400)![key] = resultData400[key] !== undefined ? resultData400[key] : [];
                }
            }
            else {
                result400 = <any>null;
            }
            return throwException("In case of using wrong parameters", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("In case the user wasn\'t found", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("In case of internal server error", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

/** Repräsentiert einen Betrieb */
export class AddBetriebDto implements IAddBetriebDto {
    /** Der Name eines Betriebes */
    name!: string;
    vvvo!: VvvoDto;
    /** Der vorgestellte Zusatz eines Betriebes */
    vorname!: string;
    /** Die Straße eines Betriebes */
    strasse!: string;
    /** Die PLZ eines Betriebes */
    postleitzahl!: string;
    /** Der Ort eines Betriebes */
    ort!: string;
    /** Die Email eines Betriebes */
    email!: string;

    constructor(data?: IAddBetriebDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.vvvo = new VvvoDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.vvvo = _data["vvvo"] ? VvvoDto.fromJS(_data["vvvo"]) : new VvvoDto();
            this.vorname = _data["vorname"];
            this.strasse = _data["strasse"];
            this.postleitzahl = _data["postleitzahl"];
            this.ort = _data["ort"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): AddBetriebDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddBetriebDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["vvvo"] = this.vvvo ? this.vvvo.toJSON() : <any>undefined;
        data["vorname"] = this.vorname;
        data["strasse"] = this.strasse;
        data["postleitzahl"] = this.postleitzahl;
        data["ort"] = this.ort;
        data["email"] = this.email;
        return data;
    }
}

/** Repräsentiert einen Betrieb */
export interface IAddBetriebDto {
    /** Der Name eines Betriebes */
    name: string;
    vvvo: VvvoDto;
    /** Der vorgestellte Zusatz eines Betriebes */
    vorname: string;
    /** Die Straße eines Betriebes */
    strasse: string;
    /** Die PLZ eines Betriebes */
    postleitzahl: string;
    /** Der Ort eines Betriebes */
    ort: string;
    /** Die Email eines Betriebes */
    email: string;
}

/** Provides a Request-Container for a Checklisten Eingabe entry */
export class AddChecklistenEingabeDto implements IAddChecklistenEingabeDto {
    /** A unique ID of a Betrieb */
    betriebId!: number;
    /** A unique ID of a Checkliste */
    checklistenId!: number;
    /** Name of the concrete ChecklistenEingabe */
    checklistenEingabeName!: string;
    /** The content of ChecklistenEingabe */
    eingabe!: string;
    /** Creation date of the ChecklistenEingabe */
    createdAtUtc!: Date;
    /** Shows if ChecklistenEingabe saved as draft */
    isDraft?: boolean;

    constructor(data?: IAddChecklistenEingabeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.betriebId = _data["betriebId"];
            this.checklistenId = _data["checklistenId"];
            this.checklistenEingabeName = _data["checklistenEingabeName"];
            this.eingabe = _data["eingabe"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>undefined;
            this.isDraft = _data["isDraft"];
        }
    }

    static fromJS(data: any): AddChecklistenEingabeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddChecklistenEingabeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["betriebId"] = this.betriebId;
        data["checklistenId"] = this.checklistenId;
        data["checklistenEingabeName"] = this.checklistenEingabeName;
        data["eingabe"] = this.eingabe;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : <any>undefined;
        data["isDraft"] = this.isDraft;
        return data;
    }
}

/** Provides a Request-Container for a Checklisten Eingabe entry */
export interface IAddChecklistenEingabeDto {
    /** A unique ID of a Betrieb */
    betriebId: number;
    /** A unique ID of a Checkliste */
    checklistenId: number;
    /** Name of the concrete ChecklistenEingabe */
    checklistenEingabeName: string;
    /** The content of ChecklistenEingabe */
    eingabe: string;
    /** Creation date of the ChecklistenEingabe */
    createdAtUtc: Date;
    /** Shows if ChecklistenEingabe saved as draft */
    isDraft?: boolean;
}

/** Represents Request-Container for saving the ChecklistenEingabe */
export class AddChecklistenEingabeRequestDto implements IAddChecklistenEingabeRequestDto {
    checklistenEingabe!: AddChecklistenEingabeDto;

    constructor(data?: IAddChecklistenEingabeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.checklistenEingabe = new AddChecklistenEingabeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checklistenEingabe = _data["checklistenEingabe"] ? AddChecklistenEingabeDto.fromJS(_data["checklistenEingabe"]) : new AddChecklistenEingabeDto();
        }
    }

    static fromJS(data: any): AddChecklistenEingabeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddChecklistenEingabeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checklistenEingabe"] = this.checklistenEingabe ? this.checklistenEingabe.toJSON() : <any>undefined;
        return data;
    }
}

/** Represents Request-Container for saving the ChecklistenEingabe */
export interface IAddChecklistenEingabeRequestDto {
    checklistenEingabe: AddChecklistenEingabeDto;
}

/** Stellt einen Response-Container für eine Checklisten Eingabe zur Verfügung */
export class AddChecklistenEingabeResponseDto implements IAddChecklistenEingabeResponseDto {
    checklistenEingabe!: ChecklistenEingabeDto;

    constructor(data?: IAddChecklistenEingabeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.checklistenEingabe = new ChecklistenEingabeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checklistenEingabe = _data["checklistenEingabe"] ? ChecklistenEingabeDto.fromJS(_data["checklistenEingabe"]) : new ChecklistenEingabeDto();
        }
    }

    static fromJS(data: any): AddChecklistenEingabeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddChecklistenEingabeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checklistenEingabe"] = this.checklistenEingabe ? this.checklistenEingabe.toJSON() : <any>undefined;
        return data;
    }
}

/** Stellt einen Response-Container für eine Checklisten Eingabe zur Verfügung */
export interface IAddChecklistenEingabeResponseDto {
    checklistenEingabe: ChecklistenEingabeDto;
}

/** Represents Request-Container for saving the ChecklistenEingaben */
export class AddChecklistenEingabenRequestDto implements IAddChecklistenEingabenRequestDto {
    /** ChecklistenEingabe */
    checklistenEingaben!: AddChecklistenEingabeDto[];

    constructor(data?: IAddChecklistenEingabenRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.checklistenEingaben = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["checklistenEingaben"])) {
                this.checklistenEingaben = [] as any;
                for (let item of _data["checklistenEingaben"])
                    this.checklistenEingaben!.push(AddChecklistenEingabeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddChecklistenEingabenRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddChecklistenEingabenRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.checklistenEingaben)) {
            data["checklistenEingaben"] = [];
            for (let item of this.checklistenEingaben)
                data["checklistenEingaben"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents Request-Container for saving the ChecklistenEingaben */
export interface IAddChecklistenEingabenRequestDto {
    /** ChecklistenEingabe */
    checklistenEingaben: AddChecklistenEingabeDto[];
}

/** Stellt einen Response-Container für eine Checklisten Eingabe zur Verfügung */
export class AddChecklistenEingabenResponseDto implements IAddChecklistenEingabenResponseDto {
    /** Checklisten Eingabe */
    checklistenEingaben!: ChecklistenEingabeDto[];

    constructor(data?: IAddChecklistenEingabenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.checklistenEingaben = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["checklistenEingaben"])) {
                this.checklistenEingaben = [] as any;
                for (let item of _data["checklistenEingaben"])
                    this.checklistenEingaben!.push(ChecklistenEingabeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddChecklistenEingabenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddChecklistenEingabenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.checklistenEingaben)) {
            data["checklistenEingaben"] = [];
            for (let item of this.checklistenEingaben)
                data["checklistenEingaben"].push(item.toJSON());
        }
        return data;
    }
}

/** Stellt einen Response-Container für eine Checklisten Eingabe zur Verfügung */
export interface IAddChecklistenEingabenResponseDto {
    /** Checklisten Eingabe */
    checklistenEingaben: ChecklistenEingabeDto[];
}

export class AuthResponseDto implements IAuthResponseDto {
    /** Available Token */
    token?: string | undefined;
    /** Indicates if the user has already logged in before */
    firstLogin?: boolean;

    constructor(data?: IAuthResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.firstLogin = _data["firstLogin"];
        }
    }

    static fromJS(data: any): AuthResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["firstLogin"] = this.firstLogin;
        return data;
    }
}

export interface IAuthResponseDto {
    /** Available Token */
    token?: string | undefined;
    /** Indicates if the user has already logged in before */
    firstLogin?: boolean;
}

/** Repräsentiert einen Betrieb */
export class BetriebDto implements IBetriebDto {
    /** Der Name eines Betriebes */
    name!: string;
    vvvo!: VvvoDto;
    /** Der vorgestellte Zusatz eines Betriebes */
    vorname!: string;
    /** Die Straße eines Betriebes */
    strasse!: string;
    /** Die PLZ eines Betriebes */
    postleitzahl!: string;
    /** Der Ort eines Betriebes */
    ort!: string;
    /** Die Email eines Betriebes */
    email!: string;
    /** Eine eindeutige Id eines Betriebes */
    id!: number;
    authorized?: boolean;

    constructor(data?: IBetriebDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.vvvo = new VvvoDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.vvvo = _data["vvvo"] ? VvvoDto.fromJS(_data["vvvo"]) : new VvvoDto();
            this.vorname = _data["vorname"];
            this.strasse = _data["strasse"];
            this.postleitzahl = _data["postleitzahl"];
            this.ort = _data["ort"];
            this.email = _data["email"];
            this.id = _data["id"];
            this.authorized = _data["authorized"];
        }
    }

    static fromJS(data: any): BetriebDto {
        data = typeof data === 'object' ? data : {};
        let result = new BetriebDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["vvvo"] = this.vvvo ? this.vvvo.toJSON() : <any>undefined;
        data["vorname"] = this.vorname;
        data["strasse"] = this.strasse;
        data["postleitzahl"] = this.postleitzahl;
        data["ort"] = this.ort;
        data["email"] = this.email;
        data["id"] = this.id;
        data["authorized"] = this.authorized;
        return data;
    }
}

/** Repräsentiert einen Betrieb */
export interface IBetriebDto {
    /** Der Name eines Betriebes */
    name: string;
    vvvo: VvvoDto;
    /** Der vorgestellte Zusatz eines Betriebes */
    vorname: string;
    /** Die Straße eines Betriebes */
    strasse: string;
    /** Die PLZ eines Betriebes */
    postleitzahl: string;
    /** Der Ort eines Betriebes */
    ort: string;
    /** Die Email eines Betriebes */
    email: string;
    /** Eine eindeutige Id eines Betriebes */
    id: number;
    authorized?: boolean;
}

/** Stellt einen Request-Container für einen Betrieb zur Verfügung */
export class BetriebRequestDto implements IBetriebRequestDto {
    betrieb!: AddBetriebDto;

    constructor(data?: IBetriebRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.betrieb = new AddBetriebDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.betrieb = _data["betrieb"] ? AddBetriebDto.fromJS(_data["betrieb"]) : new AddBetriebDto();
        }
    }

    static fromJS(data: any): BetriebRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BetriebRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["betrieb"] = this.betrieb ? this.betrieb.toJSON() : <any>undefined;
        return data;
    }
}

/** Stellt einen Request-Container für einen Betrieb zur Verfügung */
export interface IBetriebRequestDto {
    betrieb: AddBetriebDto;
}

/** Repräsentiert einen Betriebe eines Users */
export class BetriebResponseDto implements IBetriebResponseDto {
    betrieb!: BetriebDto;

    constructor(data?: IBetriebResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.betrieb = new BetriebDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.betrieb = _data["betrieb"] ? BetriebDto.fromJS(_data["betrieb"]) : new BetriebDto();
        }
    }

    static fromJS(data: any): BetriebResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BetriebResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["betrieb"] = this.betrieb ? this.betrieb.toJSON() : <any>undefined;
        return data;
    }
}

/** Repräsentiert einen Betriebe eines Users */
export interface IBetriebResponseDto {
    betrieb: BetriebDto;
}

export class BetriebWithChecklistenEingabenDto implements IBetriebWithChecklistenEingabenDto {
    /** Der Name eines Betriebes */
    name!: string;
    vvvo!: VvvoDto;
    /** Der vorgestellte Zusatz eines Betriebes */
    vorname!: string;
    /** Die Straße eines Betriebes */
    strasse!: string;
    /** Die PLZ eines Betriebes */
    postleitzahl!: string;
    /** Der Ort eines Betriebes */
    ort!: string;
    /** Die Email eines Betriebes */
    email!: string;
    /** Eine eindeutige Id eines Betriebes */
    id!: number;
    authorized?: boolean;
    checklistenEingaben?: ChecklistenEingabeDto[] | undefined;

    constructor(data?: IBetriebWithChecklistenEingabenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.vvvo = new VvvoDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.vvvo = _data["vvvo"] ? VvvoDto.fromJS(_data["vvvo"]) : new VvvoDto();
            this.vorname = _data["vorname"];
            this.strasse = _data["strasse"];
            this.postleitzahl = _data["postleitzahl"];
            this.ort = _data["ort"];
            this.email = _data["email"];
            this.id = _data["id"];
            this.authorized = _data["authorized"];
            if (Array.isArray(_data["checklistenEingaben"])) {
                this.checklistenEingaben = [] as any;
                for (let item of _data["checklistenEingaben"])
                    this.checklistenEingaben!.push(ChecklistenEingabeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BetriebWithChecklistenEingabenDto {
        data = typeof data === 'object' ? data : {};
        let result = new BetriebWithChecklistenEingabenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["vvvo"] = this.vvvo ? this.vvvo.toJSON() : <any>undefined;
        data["vorname"] = this.vorname;
        data["strasse"] = this.strasse;
        data["postleitzahl"] = this.postleitzahl;
        data["ort"] = this.ort;
        data["email"] = this.email;
        data["id"] = this.id;
        data["authorized"] = this.authorized;
        if (Array.isArray(this.checklistenEingaben)) {
            data["checklistenEingaben"] = [];
            for (let item of this.checklistenEingaben)
                data["checklistenEingaben"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBetriebWithChecklistenEingabenDto {
    /** Der Name eines Betriebes */
    name: string;
    vvvo: VvvoDto;
    /** Der vorgestellte Zusatz eines Betriebes */
    vorname: string;
    /** Die Straße eines Betriebes */
    strasse: string;
    /** Die PLZ eines Betriebes */
    postleitzahl: string;
    /** Der Ort eines Betriebes */
    ort: string;
    /** Die Email eines Betriebes */
    email: string;
    /** Eine eindeutige Id eines Betriebes */
    id: number;
    authorized?: boolean;
    checklistenEingaben?: ChecklistenEingabeDto[] | undefined;
}

export class BetriebWithChecklistenEingabenResponseDto implements IBetriebWithChecklistenEingabenResponseDto {
    betrieb!: BetriebWithChecklistenEingabenDto;

    constructor(data?: IBetriebWithChecklistenEingabenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.betrieb = new BetriebWithChecklistenEingabenDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.betrieb = _data["betrieb"] ? BetriebWithChecklistenEingabenDto.fromJS(_data["betrieb"]) : new BetriebWithChecklistenEingabenDto();
        }
    }

    static fromJS(data: any): BetriebWithChecklistenEingabenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BetriebWithChecklistenEingabenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["betrieb"] = this.betrieb ? this.betrieb.toJSON() : <any>undefined;
        return data;
    }
}

export interface IBetriebWithChecklistenEingabenResponseDto {
    betrieb: BetriebWithChecklistenEingabenDto;
}

/** Repräsentiert einen Betriebe eines Users */
export class BetriebeWithChecklistenEingabenResponseDto implements IBetriebeWithChecklistenEingabenResponseDto {
    /** Eine Liste mit den Betrieben eines Users */
    betriebe!: BetriebWithChecklistenEingabenDto[];

    constructor(data?: IBetriebeWithChecklistenEingabenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.betriebe = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["betriebe"])) {
                this.betriebe = [] as any;
                for (let item of _data["betriebe"])
                    this.betriebe!.push(BetriebWithChecklistenEingabenDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BetriebeWithChecklistenEingabenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BetriebeWithChecklistenEingabenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.betriebe)) {
            data["betriebe"] = [];
            for (let item of this.betriebe)
                data["betriebe"].push(item.toJSON());
        }
        return data;
    }
}

/** Repräsentiert einen Betriebe eines Users */
export interface IBetriebeWithChecklistenEingabenResponseDto {
    /** Eine Liste mit den Betrieben eines Users */
    betriebe: BetriebWithChecklistenEingabenDto[];
}

export class ChangeEmailRequestDto implements IChangeEmailRequestDto {
    userId!: string;
    token!: string;
    newEmail!: string;

    constructor(data?: IChangeEmailRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.token = _data["token"];
            this.newEmail = _data["newEmail"];
        }
    }

    static fromJS(data: any): ChangeEmailRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeEmailRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["token"] = this.token;
        data["newEmail"] = this.newEmail;
        return data;
    }
}

export interface IChangeEmailRequestDto {
    userId: string;
    token: string;
    newEmail: string;
}

export class ChangePasswordRequestDto implements IChangePasswordRequestDto {
    currentPassword!: string;
    newPassword!: string;
    confirmPassword!: string;

    constructor(data?: IChangePasswordRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IChangePasswordRequestDto {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
}

export class CheckVvvoRequestDto implements ICheckVvvoRequestDto {
    vvvo!: VvvoDto;

    constructor(data?: ICheckVvvoRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.vvvo = new VvvoDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vvvo = _data["vvvo"] ? VvvoDto.fromJS(_data["vvvo"]) : new VvvoDto();
        }
    }

    static fromJS(data: any): CheckVvvoRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckVvvoRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vvvo"] = this.vvvo ? this.vvvo.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICheckVvvoRequestDto {
    vvvo: VvvoDto;
}

export class CheckVvvoResponseDto implements ICheckVvvoResponseDto {
    betriebExists!: boolean;
    authorizationExists!: boolean;
    authorizationConfirmed!: boolean;
    existedEmail?: string | undefined;

    constructor(data?: ICheckVvvoResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.betriebExists = _data["betriebExists"];
            this.authorizationExists = _data["authorizationExists"];
            this.authorizationConfirmed = _data["authorizationConfirmed"];
            this.existedEmail = _data["existedEmail"];
        }
    }

    static fromJS(data: any): CheckVvvoResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new CheckVvvoResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["betriebExists"] = this.betriebExists;
        data["authorizationExists"] = this.authorizationExists;
        data["authorizationConfirmed"] = this.authorizationConfirmed;
        data["existedEmail"] = this.existedEmail;
        return data;
    }
}

export interface ICheckVvvoResponseDto {
    betriebExists: boolean;
    authorizationExists: boolean;
    authorizationConfirmed: boolean;
    existedEmail?: string | undefined;
}

/** Eine Checkliste ist ein Formular welches zur Erhebung von Daten verwendet wird */
export class ChecklisteDto implements IChecklisteDto {
    /** Eine eindeutige (unique) Id einer Checkliste */
    id!: number;
    /** Die Bezeichnung einer Checkliste, z.B.: "Kupierverzicht" */
    name?: string | undefined;
    /** Beschreibung der Checkliste */
    description?: string | undefined;
    /** Version der Checkliste */
    version?: string | undefined;
    /** Der eigentliche Inhalt der Checkliste im Json Format */
    content?: string | undefined;
    /** Das Erstellungsdatum der Checkliste */
    createdAtUtc!: Date;

    constructor(data?: IChecklisteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.version = _data["version"];
            this.content = _data["content"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChecklisteDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklisteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["version"] = this.version;
        data["content"] = this.content;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : <any>undefined;
        return data;
    }
}

/** Eine Checkliste ist ein Formular welches zur Erhebung von Daten verwendet wird */
export interface IChecklisteDto {
    /** Eine eindeutige (unique) Id einer Checkliste */
    id: number;
    /** Die Bezeichnung einer Checkliste, z.B.: "Kupierverzicht" */
    name?: string | undefined;
    /** Beschreibung der Checkliste */
    description?: string | undefined;
    /** Version der Checkliste */
    version?: string | undefined;
    /** Der eigentliche Inhalt der Checkliste im Json Format */
    content?: string | undefined;
    /** Das Erstellungsdatum der Checkliste */
    createdAtUtc: Date;
}

/** Stellt einen Request-Container für eine Checklisten Eingabe zur Verfügung */
export class ChecklistenEingabeDto implements IChecklistenEingabeDto {
    /** A unique ID of a Betrieb */
    betriebId!: number;
    /** A unique ID of a Checkliste */
    checklistenId!: number;
    /** Name of the concrete ChecklistenEingabe */
    checklistenEingabeName!: string;
    /** The content of ChecklistenEingabe */
    eingabe!: string;
    /** Creation date of the ChecklistenEingabe */
    createdAtUtc!: Date;
    /** Shows if ChecklistenEingabe saved as draft */
    isDraft?: boolean;
    /** Eine eindeutige Id einer Checklisten Eingabe */
    id?: number;
    /** Indicates whether ChecklistenEingabe is valid comparing with Checkliste and Pdf Template */
    isValid?: boolean | undefined;
    /** Name of the concrete ChecklistenEingabe */
    checklistenName!: string;
    /** Indicates whether Checkliste related to ChecklistenEingabe has newer version */
    isOutdated?: boolean;
    /** User who crated ChecklistenEingabe */
    author?: string | undefined;
    description?: string | undefined;
    /** A uniqueId for ChecklistenEingabe */
    uniqueId?: string;

    constructor(data?: IChecklistenEingabeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.betriebId = _data["betriebId"];
            this.checklistenId = _data["checklistenId"];
            this.checklistenEingabeName = _data["checklistenEingabeName"];
            this.eingabe = _data["eingabe"];
            this.createdAtUtc = _data["createdAtUtc"] ? new Date(_data["createdAtUtc"].toString()) : <any>undefined;
            this.isDraft = _data["isDraft"];
            this.id = _data["id"];
            this.isValid = _data["isValid"];
            this.checklistenName = _data["checklistenName"];
            this.isOutdated = _data["isOutdated"];
            this.author = _data["author"];
            this.description = _data["description"];
            this.uniqueId = _data["uniqueId"];
        }
    }

    static fromJS(data: any): ChecklistenEingabeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistenEingabeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["betriebId"] = this.betriebId;
        data["checklistenId"] = this.checklistenId;
        data["checklistenEingabeName"] = this.checklistenEingabeName;
        data["eingabe"] = this.eingabe;
        data["createdAtUtc"] = this.createdAtUtc ? this.createdAtUtc.toISOString() : <any>undefined;
        data["isDraft"] = this.isDraft;
        data["id"] = this.id;
        data["isValid"] = this.isValid;
        data["checklistenName"] = this.checklistenName;
        data["isOutdated"] = this.isOutdated;
        data["author"] = this.author;
        data["description"] = this.description;
        data["uniqueId"] = this.uniqueId;
        return data;
    }
}

/** Stellt einen Request-Container für eine Checklisten Eingabe zur Verfügung */
export interface IChecklistenEingabeDto {
    /** A unique ID of a Betrieb */
    betriebId: number;
    /** A unique ID of a Checkliste */
    checklistenId: number;
    /** Name of the concrete ChecklistenEingabe */
    checklistenEingabeName: string;
    /** The content of ChecklistenEingabe */
    eingabe: string;
    /** Creation date of the ChecklistenEingabe */
    createdAtUtc: Date;
    /** Shows if ChecklistenEingabe saved as draft */
    isDraft?: boolean;
    /** Eine eindeutige Id einer Checklisten Eingabe */
    id?: number;
    /** Indicates whether ChecklistenEingabe is valid comparing with Checkliste and Pdf Template */
    isValid?: boolean | undefined;
    /** Name of the concrete ChecklistenEingabe */
    checklistenName: string;
    /** Indicates whether Checkliste related to ChecklistenEingabe has newer version */
    isOutdated?: boolean;
    /** User who crated ChecklistenEingabe */
    author?: string | undefined;
    description?: string | undefined;
    /** A uniqueId for ChecklistenEingabe */
    uniqueId?: string;
}

export class ChecklistenOverviewResponseDto implements IChecklistenOverviewResponseDto {
    /** Eine Liste mit den Checklisten-Übersichten eines Betriebes */
    checklistenOverview!: ChecklistenEingabeDto[];

    constructor(data?: IChecklistenOverviewResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.checklistenOverview = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["checklistenOverview"])) {
                this.checklistenOverview = [] as any;
                for (let item of _data["checklistenOverview"])
                    this.checklistenOverview!.push(ChecklistenEingabeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChecklistenOverviewResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistenOverviewResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.checklistenOverview)) {
            data["checklistenOverview"] = [];
            for (let item of this.checklistenOverview)
                data["checklistenOverview"].push(item.toJSON());
        }
        return data;
    }
}

export interface IChecklistenOverviewResponseDto {
    /** Eine Liste mit den Checklisten-Übersichten eines Betriebes */
    checklistenOverview: ChecklistenEingabeDto[];
}

/** Stellt einen Response-Container für die Checklisten zur Verfügung */
export class ChecklistenResponseDto implements IChecklistenResponseDto {
    /** Verfügbare Checklisten */
    checklisten!: ChecklisteDto[];

    constructor(data?: IChecklistenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.checklisten = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["checklisten"])) {
                this.checklisten = [] as any;
                for (let item of _data["checklisten"])
                    this.checklisten!.push(ChecklisteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChecklistenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChecklistenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.checklisten)) {
            data["checklisten"] = [];
            for (let item of this.checklisten)
                data["checklisten"].push(item.toJSON());
        }
        return data;
    }
}

/** Stellt einen Response-Container für die Checklisten zur Verfügung */
export interface IChecklistenResponseDto {
    /** Verfügbare Checklisten */
    checklisten: ChecklisteDto[];
}

export class ConfirmEmailRequestDto implements IConfirmEmailRequestDto {
    /** Id of the user */
    userId!: string;
    /** Password */
    token!: string;

    constructor(data?: IConfirmEmailRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ConfirmEmailRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmEmailRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["token"] = this.token;
        return data;
    }
}

export interface IConfirmEmailRequestDto {
    /** Id of the user */
    userId: string;
    /** Password */
    token: string;
}

export class ConfirmUserVvvoAuthorizationRequestDto implements IConfirmUserVvvoAuthorizationRequestDto {
    authorizationId!: number;
    token!: string;

    constructor(data?: IConfirmUserVvvoAuthorizationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorizationId = _data["authorizationId"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ConfirmUserVvvoAuthorizationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmUserVvvoAuthorizationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizationId"] = this.authorizationId;
        data["token"] = this.token;
        return data;
    }
}

export interface IConfirmUserVvvoAuthorizationRequestDto {
    authorizationId: number;
    token: string;
}

export class CreateUserRequestDto implements ICreateUserRequestDto {
    /** Benutzername (E-Mail Adresse) */
    email!: string;
    /** Password */
    password!: string;

    constructor(data?: ICreateUserRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): CreateUserRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface ICreateUserRequestDto {
    /** Benutzername (E-Mail Adresse) */
    email: string;
    /** Password */
    password: string;
}

/** Stellt einen Response-Container für eine Checklisten Eingabe zur Verfügung */
export class GetChecklistenEingabeResponseDto implements IGetChecklistenEingabeResponseDto {
    checklistenEingabe!: ChecklistenEingabeDto;

    constructor(data?: IGetChecklistenEingabeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.checklistenEingabe = new ChecklistenEingabeDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checklistenEingabe = _data["checklistenEingabe"] ? ChecklistenEingabeDto.fromJS(_data["checklistenEingabe"]) : new ChecklistenEingabeDto();
        }
    }

    static fromJS(data: any): GetChecklistenEingabeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetChecklistenEingabeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checklistenEingabe"] = this.checklistenEingabe ? this.checklistenEingabe.toJSON() : <any>undefined;
        return data;
    }
}

/** Stellt einen Response-Container für eine Checklisten Eingabe zur Verfügung */
export interface IGetChecklistenEingabeResponseDto {
    checklistenEingabe: ChecklistenEingabeDto;
}

export class LoginRequestDto implements ILoginRequestDto {
    /** Benutzername, bei Mitarbeitern bestehend aus Betrieb.Id-DisplayName */
    username!: string;
    /** Password */
    password!: string;
    /** Language selected in frontend */
    language!: string;

    constructor(data?: ILoginRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): LoginRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoginRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        data["language"] = this.language;
        return data;
    }
}

export interface ILoginRequestDto {
    /** Benutzername, bei Mitarbeitern bestehend aus Betrieb.Id-DisplayName */
    username: string;
    /** Password */
    password: string;
    /** Language selected in frontend */
    language: string;
}

export class MismatchedPdfTemplateFieldDto implements IMismatchedPdfTemplateFieldDto {
    cause?: string | undefined;
    pathParts?: PdfTemplateFieldPathPartDto[] | undefined;
    possibleMatches?: any[] | undefined;
    valueType?: string | undefined;
    elementType?: string | undefined;

    constructor(data?: IMismatchedPdfTemplateFieldDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cause = _data["cause"];
            if (Array.isArray(_data["pathParts"])) {
                this.pathParts = [] as any;
                for (let item of _data["pathParts"])
                    this.pathParts!.push(PdfTemplateFieldPathPartDto.fromJS(item));
            }
            if (Array.isArray(_data["possibleMatches"])) {
                this.possibleMatches = [] as any;
                for (let item of _data["possibleMatches"])
                    this.possibleMatches!.push(item);
            }
            this.valueType = _data["valueType"];
            this.elementType = _data["elementType"];
        }
    }

    static fromJS(data: any): MismatchedPdfTemplateFieldDto {
        data = typeof data === 'object' ? data : {};
        let result = new MismatchedPdfTemplateFieldDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cause"] = this.cause;
        if (Array.isArray(this.pathParts)) {
            data["pathParts"] = [];
            for (let item of this.pathParts)
                data["pathParts"].push(item.toJSON());
        }
        if (Array.isArray(this.possibleMatches)) {
            data["possibleMatches"] = [];
            for (let item of this.possibleMatches)
                data["possibleMatches"].push(item);
        }
        data["valueType"] = this.valueType;
        data["elementType"] = this.elementType;
        return data;
    }
}

export interface IMismatchedPdfTemplateFieldDto {
    cause?: string | undefined;
    pathParts?: PdfTemplateFieldPathPartDto[] | undefined;
    possibleMatches?: any[] | undefined;
    valueType?: string | undefined;
    elementType?: string | undefined;
}

/** Response-Container containing PdfCheckliste */
export class PdfDto implements IPdfDto {
    /** Dateiname der Datei */
    filename!: string;
    /** Displayname der Datei */
    contentType!: string;
    /** Extension der Datei */
    extension!: string;
    /** DateiInhalt der Datei */
    data!: string;
    /** The size of file */
    fileSize!: number;

    constructor(data?: IPdfDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filename = _data["filename"];
            this.contentType = _data["contentType"];
            this.extension = _data["extension"];
            this.data = _data["data"];
            this.fileSize = _data["fileSize"];
        }
    }

    static fromJS(data: any): PdfDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filename"] = this.filename;
        data["contentType"] = this.contentType;
        data["extension"] = this.extension;
        data["data"] = this.data;
        data["fileSize"] = this.fileSize;
        return data;
    }
}

/** Response-Container containing PdfCheckliste */
export interface IPdfDto {
    /** Dateiname der Datei */
    filename: string;
    /** Displayname der Datei */
    contentType: string;
    /** Extension der Datei */
    extension: string;
    /** DateiInhalt der Datei */
    data: string;
    /** The size of file */
    fileSize: number;
}

/** Response-Container containing PdfCheckliste */
export class PdfResponseDto implements IPdfResponseDto {
    pdf!: PdfDto;

    constructor(data?: IPdfResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pdf = new PdfDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pdf = _data["pdf"] ? PdfDto.fromJS(_data["pdf"]) : new PdfDto();
        }
    }

    static fromJS(data: any): PdfResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pdf"] = this.pdf ? this.pdf.toJSON() : <any>undefined;
        return data;
    }
}

/** Response-Container containing PdfCheckliste */
export interface IPdfResponseDto {
    pdf: PdfDto;
}

export class PdfTemplateFieldPathPartDto implements IPdfTemplateFieldPathPartDto {
    value?: string | undefined;
    isIgnored?: boolean;

    constructor(data?: IPdfTemplateFieldPathPartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isIgnored = _data["isIgnored"];
        }
    }

    static fromJS(data: any): PdfTemplateFieldPathPartDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfTemplateFieldPathPartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isIgnored"] = this.isIgnored;
        return data;
    }
}

export interface IPdfTemplateFieldPathPartDto {
    value?: string | undefined;
    isIgnored?: boolean;
}

export class PdfTemplateValidationResultDto implements IPdfTemplateValidationResultDto {
    messages?: MismatchedPdfTemplateFieldDto[] | undefined;
    additionalData?: any | undefined;
    isValid?: boolean;

    constructor(data?: IPdfTemplateValidationResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(MismatchedPdfTemplateFieldDto.fromJS(item));
            }
            this.additionalData = _data["additionalData"];
            this.isValid = _data["isValid"];
        }
    }

    static fromJS(data: any): PdfTemplateValidationResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new PdfTemplateValidationResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        data["additionalData"] = this.additionalData;
        data["isValid"] = this.isValid;
        return data;
    }
}

export interface IPdfTemplateValidationResultDto {
    messages?: MismatchedPdfTemplateFieldDto[] | undefined;
    additionalData?: any | undefined;
    isValid?: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class RejectUserVvvoAuthorizationRequestDto implements IRejectUserVvvoAuthorizationRequestDto {
    authorizationId!: number;
    token!: string;

    constructor(data?: IRejectUserVvvoAuthorizationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authorizationId = _data["authorizationId"];
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): RejectUserVvvoAuthorizationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RejectUserVvvoAuthorizationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizationId"] = this.authorizationId;
        data["token"] = this.token;
        return data;
    }
}

export interface IRejectUserVvvoAuthorizationRequestDto {
    authorizationId: number;
    token: string;
}

export class RequestChangeEmailRequestDto implements IRequestChangeEmailRequestDto {
    newEmail!: string;

    constructor(data?: IRequestChangeEmailRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newEmail = _data["newEmail"];
        }
    }

    static fromJS(data: any): RequestChangeEmailRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestChangeEmailRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newEmail"] = this.newEmail;
        return data;
    }
}

export interface IRequestChangeEmailRequestDto {
    newEmail: string;
}

export class RequestExistingUserVvvoAuthorizationRequestDto implements IRequestExistingUserVvvoAuthorizationRequestDto {
    vvvo!: VvvoDto;
    /** Die Email eines Betriebes */
    email?: string | undefined;

    constructor(data?: IRequestExistingUserVvvoAuthorizationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.vvvo = new VvvoDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vvvo = _data["vvvo"] ? VvvoDto.fromJS(_data["vvvo"]) : new VvvoDto();
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): RequestExistingUserVvvoAuthorizationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestExistingUserVvvoAuthorizationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vvvo"] = this.vvvo ? this.vvvo.toJSON() : <any>undefined;
        data["email"] = this.email;
        return data;
    }
}

export interface IRequestExistingUserVvvoAuthorizationRequestDto {
    vvvo: VvvoDto;
    /** Die Email eines Betriebes */
    email?: string | undefined;
}

export class RequestNewUserVvvoAuthorizationRequestDto implements IRequestNewUserVvvoAuthorizationRequestDto {
    betrieb?: AddBetriebDto;

    constructor(data?: IRequestNewUserVvvoAuthorizationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.betrieb = _data["betrieb"] ? AddBetriebDto.fromJS(_data["betrieb"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestNewUserVvvoAuthorizationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestNewUserVvvoAuthorizationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["betrieb"] = this.betrieb ? this.betrieb.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRequestNewUserVvvoAuthorizationRequestDto {
    betrieb?: AddBetriebDto;
}

export class RequestNewUserVvvoAuthorizationResponseDto implements IRequestNewUserVvvoAuthorizationResponseDto {
    betrieb?: BetriebDto;

    constructor(data?: IRequestNewUserVvvoAuthorizationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.betrieb = _data["betrieb"] ? BetriebDto.fromJS(_data["betrieb"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RequestNewUserVvvoAuthorizationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestNewUserVvvoAuthorizationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["betrieb"] = this.betrieb ? this.betrieb.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRequestNewUserVvvoAuthorizationResponseDto {
    betrieb?: BetriebDto;
}

export class RequestPasswordResetRequestDto implements IRequestPasswordResetRequestDto {
    email!: string;

    constructor(data?: IRequestPasswordResetRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): RequestPasswordResetRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestPasswordResetRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IRequestPasswordResetRequestDto {
    email: string;
}

export class ResetPasswordRequestDto implements IResetPasswordRequestDto {
    userId!: string;
    token!: string;
    password!: string;
    confirmPassword?: string | undefined;

    constructor(data?: IResetPasswordRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.token = _data["token"];
            this.password = _data["password"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): ResetPasswordRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["token"] = this.token;
        data["password"] = this.password;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IResetPasswordRequestDto {
    userId: string;
    token: string;
    password: string;
    confirmPassword?: string | undefined;
}

export class SendUserCreationEmailRequestDto implements ISendUserCreationEmailRequestDto {
    /** Id of the user */
    userId!: string;

    constructor(data?: ISendUserCreationEmailRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): SendUserCreationEmailRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendUserCreationEmailRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface ISendUserCreationEmailRequestDto {
    /** Id of the user */
    userId: string;
}

/** Stellt einen Response-Container für die Übersetzungen zur Verfügung */
export class TranslationsResponseDto implements ITranslationsResponseDto {
    /** Verfügbare Übersetzungen */
    translations?: { [key: string]: { [key: string]: { [key: string]: string; }; }; } | undefined;

    constructor(data?: ITranslationsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["translations"]) {
                this.translations = {} as any;
                for (let key in _data["translations"]) {
                    if (_data["translations"].hasOwnProperty(key))
                        (<any>this.translations)![key] = _data["translations"][key];
                }
            }
        }
    }

    static fromJS(data: any): TranslationsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.translations) {
            data["translations"] = {};
            for (let key in this.translations) {
                if (this.translations.hasOwnProperty(key))
                    (<any>data["translations"])[key] = (<any>this.translations)[key];
            }
        }
        return data;
    }
}

/** Stellt einen Response-Container für die Übersetzungen zur Verfügung */
export interface ITranslationsResponseDto {
    /** Verfügbare Übersetzungen */
    translations?: { [key: string]: { [key: string]: { [key: string]: string; }; }; } | undefined;
}

export class UserDto implements IUserDto {
    /** Id of the user */
    id?: string;
    /** Benutzername (E-Mail Adresse) */
    username!: string;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["username"] = this.username;
        return data;
    }
}

export interface IUserDto {
    /** Id of the user */
    id?: string;
    /** Benutzername (E-Mail Adresse) */
    username: string;
}

export class UserProfileDto implements IUserProfileDto {
    name!: string;
    firstName!: string;
    street!: string;
    postCode!: string;
    city!: string;
    country!: string;
    userGroup!: string;
    company?: string | undefined;

    constructor(data?: IUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.street = _data["street"];
            this.postCode = _data["postCode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.userGroup = _data["userGroup"];
            this.company = _data["company"];
        }
    }

    static fromJS(data: any): UserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["street"] = this.street;
        data["postCode"] = this.postCode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["userGroup"] = this.userGroup;
        data["company"] = this.company;
        return data;
    }
}

export interface IUserProfileDto {
    name: string;
    firstName: string;
    street: string;
    postCode: string;
    city: string;
    country: string;
    userGroup: string;
    company?: string | undefined;
}

export class UserProfileRequestDto implements IUserProfileRequestDto {
    userProfile!: UserProfileDto;

    constructor(data?: IUserProfileRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userProfile = new UserProfileDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userProfile = _data["userProfile"] ? UserProfileDto.fromJS(_data["userProfile"]) : new UserProfileDto();
        }
    }

    static fromJS(data: any): UserProfileRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userProfile"] = this.userProfile ? this.userProfile.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserProfileRequestDto {
    userProfile: UserProfileDto;
}

export class UserProfileResponseDto implements IUserProfileResponseDto {
    userProfile!: UserProfileDto;

    constructor(data?: IUserProfileResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userProfile = new UserProfileDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userProfile = _data["userProfile"] ? UserProfileDto.fromJS(_data["userProfile"]) : new UserProfileDto();
        }
    }

    static fromJS(data: any): UserProfileResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserProfileResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userProfile"] = this.userProfile ? this.userProfile.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserProfileResponseDto {
    userProfile: UserProfileDto;
}

export class UserResponseDto implements IUserResponseDto {
    user!: UserDto;

    constructor(data?: IUserResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : new UserDto();
        }
    }

    static fromJS(data: any): UserResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserResponseDto {
    user: UserDto;
}

export class ValidateEmailRequestDto implements IValidateEmailRequestDto {
    /** Email */
    email!: string;

    constructor(data?: IValidateEmailRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ValidateEmailRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateEmailRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IValidateEmailRequestDto {
    /** Email */
    email: string;
}

export class ValidateEmailResponseDto implements IValidateEmailResponseDto {
    /** Email */
    isEmailValid!: boolean;

    constructor(data?: IValidateEmailResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmailValid = _data["isEmailValid"];
        }
    }

    static fromJS(data: any): ValidateEmailResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateEmailResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailValid"] = this.isEmailValid;
        return data;
    }
}

export interface IValidateEmailResponseDto {
    /** Email */
    isEmailValid: boolean;
}

export class ValidatePasswordRequestDto implements IValidatePasswordRequestDto {
    /** Password */
    password!: string;

    constructor(data?: IValidatePasswordRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ValidatePasswordRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatePasswordRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        return data;
    }
}

export interface IValidatePasswordRequestDto {
    /** Password */
    password: string;
}

export class VvvoDto implements IVvvoDto {
    value!: string;

    constructor(data?: IVvvoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): VvvoDto {
        data = typeof data === 'object' ? data : {};
        let result = new VvvoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IVvvoDto {
    value: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}